// 测试服务器配置
// export const URL = 'http://192.168.0.105:8000/';
// export const URL = 'http://192.168.202.133:8000/';  //热点  注意修改花生壳映射和DJANGO配置


// 生产服务器配置
export const URL = 'https://www.wanghozz.com/';




export const API = URL;

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// 微信授权配置~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// 测试APPID  CALLBACK配置
// const APPID = 'wx9cb333411ea2f169';
// const USERINFOAPI = 'http://front.s7.tunnelfrp.com/wechat/userinfo/';

// 生产APPID  CALLBACK配置
const APPID = 'wxee60b0d5d1b08020';
const USERINFOAPI = 'https://www.wanghozz.com/wechat/userinfo/';




// export function getOpenId() {   不用这个函数，直接用微信授权链接
//     let codeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
//         APPID +
//         '&redirect_uri=' + encodeURIComponent(OPENIDAPI) +
//         '&response_type=code&scope=snsapi_base&state=' + 'wangho' + '#wechat_redirect'
//     window.location.href = codeUrl
// }
export function getUserInfo() {
    let codeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        APPID +
        '&redirect_uri=' + encodeURIComponent(USERINFOAPI) +
        '&response_type=code&scope=snsapi_userinfo&state=' + 'wangho' + '#wechat_redirect'
    window.location.href = codeUrl
}